// Supported locales for PRHS UI. Kept in sync with the GFN UAS static pages
// project (gfn/uas/user-acquisition-service-static-pages) so the language
// dropdown and ui_locales handling match the rest of the GFN web surface.
export const languageMap = {
  'cs': 'cs-CZ',
  'da': 'da-DK',
  'de': 'de-DE',
  'en': 'en-US',
  'en-us': 'en-US',
  'en-gb': 'en-GB',
  'es-es': 'es-ES',
  'es': 'es-MX',
  'fr': 'fr-FR',
  'it': 'it-IT',
  'nl': 'nl-NL',
  'nb': 'nb-NO',
  'pl': 'pl-PL',
  'pt': 'pt-BR',
  'pt-pt': 'pt-PT',
  'ro': 'ro-RO',
  'fi': 'fi-FI',
  'sv': 'sv-SE',
  'tr': 'tr-TR',
  'ru': 'ru-RU',
  'th': 'th-TH',
  'ko': 'ko-KR',
  'ja': 'ja-JP',
  'zh': 'zh-CN',
  'zh-hk': 'zh-TW',
  'zh-mo': 'zh-TW',
  'zh-tw': 'zh-TW',
  'zh-hant': 'zh-TW'
};

export const availableLanguages = [
  { value: 'cs-CZ', label: 'Čeština' },
  { value: 'da-DK', label: 'Dansk' },
  { value: 'de-DE', label: 'Deutsch' },
  { value: 'en-GB', label: 'English (UK)' },
  { value: 'en-US', label: 'English (US)' },
  { value: 'es-ES', label: 'Español (España)' },
  { value: 'es-MX', label: 'Español (México)' },
  { value: 'fr-FR', label: 'Français' },
  { value: 'it-IT', label: 'Italiano' },
  { value: 'nl-NL', label: 'Nederlands' },
  { value: 'nb-NO', label: 'Norsk (Bokmål)' },
  { value: 'pl-PL', label: 'Polski' },
  { value: 'pt-BR', label: 'Português (Brasil)' },
  { value: 'pt-PT', label: 'Português (Portugal)' },
  { value: 'ro-RO', label: 'Română' },
  { value: 'fi-FI', label: 'Suomi' },
  { value: 'sv-SE', label: 'Svenska' },
  { value: 'tr-TR', label: 'Türkçe' },
  { value: 'ru-RU', label: 'Русский' },
  { value: 'th-TH', label: 'ภาษาไทย' },
  { value: 'ko-KR', label: '한국어' },
  { value: 'ja-JP', label: '日本語' },
  { value: 'zh-CN', label: '简体中文' },
  { value: 'zh-TW', label: '繁體中文' }
];

export const rtlLanguages = [];
